module.exports = __webpack_public_path__ + "static/media/reclaim.fd9fabda.png";